<div class="container-data">
    <div class="edit-view">
        <div class="form-formula tem-field">
            <div class="tem-field-label-row">
                <label class="tem-field-label">Fórmula de Cor</label>
                <button tabindex="-1" type="button" nz-button nzType="text" nzSize="small" aria-label="Ajuda" (click)="printHelp()">
                    <nz-icon nzType="question-circle"></nz-icon>
                </button>
            </div>
            <textarea nz-input
                placeholder="Fórmula"
                aria-label="Regra de Cor"
                #value
                [(ngModel)]="formulastr" name="lo" class="full"
                [nzAutosize]="{ minRows: 6, maxRows: 14 }"></textarea>
        </div>
    </div>
    <div class="button-content">
        <span><button nz-button nzType="primary" (click)="close()">Confirmar</button></span>
    </div>
</div>
